import { render, staticRenderFns } from "./PaymentSelect.vue?vue&type=template&id=64bf7d04&scoped=true"
import script from "./PaymentSelect.vue?vue&type=script&lang=js"
export * from "./PaymentSelect.vue?vue&type=script&lang=js"
import style0 from "./PaymentSelect.vue?vue&type=style&index=0&id=64bf7d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bf7d04",
  null
  
)

export default component.exports